import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'
import { config } from '../../config.js'
import {
  Avatar,
  Box,
  Button,
  Divider,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Grid,
  Hidden,
  Icon,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Tabs,
  TextField,
  Typography,
} from '@material-ui/core'
import AvatarGroup from '@material-ui/lab/AvatarGroup'
import { withStyles } from '@material-ui/core/styles'
import { isNil, startCase } from 'lodash'
import InfiniteScroll from 'react-infinite-scroll-component'
import AppTopBar from '../../components/AppTopBar'
import DestinationList from '../../components/lists/DestinationList'
import ButtonFilter from '../../components/filters/ButtonFilter'
import SliderFilter from '../../components/filters/SliderFilter'
import ListFilter from '../../components/filters/ListFilter'
import SearchPanel from '../../components/SearchPanel'
import Cookies from 'universal-cookie'
import { stringToColor } from '../../utils/helpers'
import { THINGS_TO_DO, INTERESTS, DISTANCE } from '../../utils/lists'

const cookies = new Cookies();
const API = config.api.TRAVEL_URL
let abortController = new AbortController()

const CustomTab = ({ className, children }) => {
  return <Box component="div" className={className} children={children} />;
};

class GroupHome extends Component {
  constructor(props) {
    super(props)

    this.state = {
      id: props.group_id,
      name: "",
      member_id: null,
      members: [],
      likes: [],
      is_organizer: null,
      is_member: null,

      isLoading: true,
      hasMore: true,
      page: 0,
      group: null,
      destination_groups: [],
      filters: {
        saved: [],
      },
      // search_params: {
      //   travelers: {
      //     adults: 1,
      //     children: 0,
      //     infants: 0,
      //   },
      //   dates: {
      //     dates_type: 'cheapest',
      //     start_date: null,
      //     end_date: null,
      //     nights: [2, 10],
      //   },
      //   from: null,
      //   to: null,
      // },
      search_params: {
        ...this.props.search_params,
      },

      signinDialogOpened: false,
      showInvitationLink: false,
      showEditDialog: false,
      isMenuOpened: false,
      anchorEl: null,
    }
  }

  componentDidMount() {
    if (!this.props.user.is_registered) {
      cookies.set('redirectTo', `/group/${this.props.group_id}`, {
        path: '/',
        domain: config.api.DOMAIN,
        expires: new Date(Date.now() + 2 * (60 * 60 * 1000) ),
      })
    } else {
      cookies.remove('redirectTo', { path: '/', domain: config.api.DOMAIN });
    }

    this.getGroup()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.is_registered !== this.props.user.is_registered) {
      this.getGroup()
    }
  }

  handleDialogClose = () => {
    this.setState({
      showEditDialog: false,
    })
  }

  handleMenuClose = (event) => {
    this.setState({isMenuOpened: false, anchorEl: null})
  }

  handleMenuOpen = (event) => {
    this.setState({isMenuOpened: true, anchorEl: event.currentTarget})
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value, error: null});
  }

  handleUpdateGroup = () => {
    const user_jwt_token = cookies.get('jwt')

    if (this.props.user.is_registered && user_jwt_token !== undefined) {
      fetch(config.api.TRAVEL_URL + '/groups/' + this.state.id, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user_jwt_token}`,
        },
        dataType: 'json',
        // We convert the React state to JSON and send it as the POST body
        body: JSON.stringify({
          group: {
            name: this.state.name,
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        this.setState({showEditDialog: false})

        if (data.user) {
          this.props.onUpdateUser(data.user)
        }
      })
    }
  }

  handleLeaveGroup = () => {
    const user_jwt_token = cookies.get('jwt')

    if (this.props.user.is_registered && user_jwt_token !== undefined) {
      fetch(config.api.TRAVEL_URL + '/groups/' + this.state.id + '/leave', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user_jwt_token}`,
        },
        dataType: 'json',
      })
      .then(response => response.json())
      .then(data => {
        this.setState({showEditDialog: false})

        if (data.user) {
          this.props.onUpdateUser(data.user)
          this.props.history.push('/')
        }
      })
    }
  }

  getGroup = () => {
    fetch(API + `/groups/${this.props.group_id}`,
    {
      headers: {
        'Authorization': `Bearer ${cookies.get('jwt')}`
      }
    })
    .then(response => response.json())
    .then(data => {

      if (data.id !== undefined) {
        this.setState({
          members: data.members,
          is_organizer: data.is_organizer,
          is_member: data.is_member,
          member_id: data.member_id,
          name: data.name,
        }, this.getDestinations)
      } else {
        this.props.history.push('/trips')
      }

    })
  }

  joinGroup = () => {
    fetch(API + `/groups/${this.props.group_id}/join`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cookies.get('jwt')}`,
      },
      dataType: 'json',
    })
    .then(response => response.json())
    .then(data => {
      this.setState({
        members: data.members,
        is_organizer: data.is_organizer,
        is_member: data.is_member,
        member_id: data.member_id,
        name: data.name,
        showInvitationLink: (data.members.length < 2),
      }, this.getDestinations)
    })
  }

  openSigninModal = () => {
    this.setState({
      signinDialogOpened: true,
    })
  }

  handleSigninChange = (flag, dialogType = 'signup') => {
    this.setState({
      signinDialogOpened: flag,
    })
  }

  handleReloadResults = () => {
    this.setState({
      destination_groups: [],
      isLoading: true,
    }, this.getDestinations)
  }

  handleFiltersChange = (event) => {
    // console.log({ filters: {...this.state.filters, ...event.target.value} })
    this.setState({
      filters: {...this.state.filters, ...event.target.value},
      page: 0,
      destination_groups: [],
    }, this.getDestinations);
  }

  handleSearch = (search_params = {}) => {
    let { dates, ...rest } = search_params
    let dates_params = {}

    if (Object.keys(dates).length > 0) {
      dates_params = Object.entries(dates).reduce((a,[k,v]) => (v === null ? a : (a[k]=v, a)), {})
    }

    if (Object.keys(dates_params).length > 0) {
      dates_params = {dates: dates_params}
    }

    search_params = {...rest, ...dates_params}

    this.setState({
      search_params: {...this.state.search_params, ...search_params},
      page: 0,
      destination_groups: [],
    }, this.getDestinations)
  }

  getDestinations = () => {
    let travel_preference = (this.props.user ? this.props.user.travel_preference : null)
    let { filters, search_params } = this.state
    let { dates, travelers } = search_params
    let location_from = (search_params && search_params.from ? search_params.from[0] : null)
    let location_to = (search_params && search_params.to ? search_params.to[0] : null)

    abortController.abort()
    abortController = new AbortController();
    const signal = abortController.signal

    if ((this.state.is_member || this.state.is_organizer) && this.state.members.length > 0) {
      this.setState({isLoading: true})

      fetch(API + `/groups/${this.props.group_id}/destinations` +
                  '?page=' + (this.state.page + 1) +

                  (travelers && travelers.adults ? '&adults=' + travelers.adults : '') +
                  (travelers && travelers.children ? '&children=' + travelers.children : '') +
                  (travelers && travelers.infants ? '&infants=' + travelers.infants : '') +

                  (dates && dates.dates_type ? '&dates_type=' + dates.dates_type : '') +
                  (dates && dates.start_date ? '&start_date=' + dates.start_date : '') +
                  (dates && dates.end_date ? '&end_date=' + dates.end_date : '') +
                  (dates && dates.nights ? '&nights=' + dates.nights : '') +

                  (location_to && location_to.location_type === 'country' ? '&country=' + location_to.country : '') +
                  (location_to && location_to.country_code ? '&country_code=' + location_to.country_code : '') +

                  (location_to && !['country', 'state_or_region'].includes(location_to.location_type) && location_to.slug ? '&location_to=' + location_to.slug : '') +
                  (location_to && !['country', 'state_or_region'].includes(location_to.location_type) && location_to.latitude ? '&latitude_to=' + location_to.latitude : '') +
                  (location_to && !['country', 'state_or_region'].includes(location_to.location_type) && location_to.longitude ? '&longitude_to=' + location_to.longitude : '') +

                  (location_from && location_from.slug ? '&location_from=' + location_from.slug : '') +
                  (location_from && location_from.latitude ? '&latitude_from=' + location_from.latitude : '') +
                  (location_from && location_from.longitude ? '&longitude_from=' + location_from.longitude : '') +

                  (filters && filters.budget !== undefined ? '&budget=' + filters.budget : '') +
                  (filters && filters.weather !== undefined ? '&weather=' + filters.weather.join(',') : '') +
                  (filters && filters.things_to_do !== undefined && !filters.things_to_do.includes('all') ? '&things_to_do=' + filters.things_to_do : '') +
                  (filters && filters.saved !== undefined && filters.saved.length > 0 ? '&saved=' + filters.saved.join(',') : '')
                  ,
      {
        headers: {
          'Authorization': `Bearer ${cookies.get('jwt')}`
        },
        signal: signal,
      })
      .then(response => response.json())
      .then(data => {
        let group = data.destination_groups[0]

        if (group) {
          this.setState(prevState => ({
            isLoading: false,
            destination_groups: prevState.page === 0 ? data.destination_groups : [...prevState.destination_groups, ...data.destination_groups],
            hasMore: group.has_next_page,
            page: prevState.page + 1,
          }))
        }
      })
    }
  }

  copyLink = (link) => {
    window.gtag('event', 'share', {link: link});
    navigator.clipboard.writeText(link)
  }

  render() {
    const link = `${config.env !== 'development' ? 'https://www' + config.api.DOMAIN : 'http://localhost:5200'}/group/${this.props.group_id}`
    const { classes, user } = this.props
    const { isMenuOpened } = this.state
    const menuId = 'menu';

    return (
      <Fragment>
        <Helmet>
          <title>{`Discover with friends & family`}</title>
        </Helmet>
        <AppTopBar
          hideMenu={true}
          hideBottomMenu={true}
          showBackButton={true}
          backButtonPath={'/explore'}
          onLocationChanged={this.props.onLocationChanged}
          onLocationCleared={this.props.onLocationCleared}
          onCurrencyChange={this.handleReloadResults}
          onChange={this.props.onFilterChange}
          onSigninModalChanged={this.handleSigninChange}
          onSignin={this.props.onSignin}
          user={this.props.user}
          address={startCase(this.props.address)}
          tabSelected={this.props.tabSelected || 'explore'}
          openedSigninDialog={this.state.signinDialogOpened}
          signinDialogType={this.state.openedSigninDialogType !== null && this.state.openedSigninDialogType}
        />

        <div className="destinations explore">
          <div>
            <Paper square className={classes.headlinePaper} style={{marginBottom: -20, paddingBottom: 0, backgroundColor: '#fafafa'}}>

              <h2 className={classes.headline}>
                <div style={{margin: '20px -10px 30px -10px'}}>
                  <SearchPanel
                    center={true}
                    // expandable={isWidthDown('xs', this.props.width) ? true : false}
                    expandable={true}
                    locationFrom={this.state.from_address}
                    search_params={this.props.search_params}
                    onSearch={this.handleSearch}
                  />
                </div>

                <strong className="main-title" style={{fontWeight: 800}}>
                  {this.state.name || 'Travel group'}
                  <IconButton
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={this.handleMenuOpen}
                    onClose={this.handleMenuClose}
                    className={classes.menuBox}
                    color="inherit">
                      <Icon className={`${classes.menuIcon} material-icons-outlined notranslate`}>settings</Icon>
                  </IconButton>
                  <br/>
                </strong>
                {/* <small className={classes.subtitle}></small> */}

                <div style={{padding: '0px 20px 0px 0px', verticalAlign: 'super', minHeight: 81, display: 'block'}}>
                  <small className={classes.subtitle} style={{marginBottom: 10, marginTop: 5}}>
                    Members
                  </small>
                  {this.state.members ?
                    <AvatarGroup classes={{avatar: classes.avatarSmall, root: classes.avatarGroup}} max={5}>
                      {this.state.members.map((member, i) => {
                        return <Avatar key={i} className={classes.avatarSmall} style={{backgroundColor: stringToColor(member.first_name), color: '#fff'}} src={member.image} alt={member.first_name}/>
                      })}
                      {/* {Array.from(new Array(5 - this.state.members.length)).map((a, i) => {
                        return <Avatar key={i+5} className={classes.avatarSmall}/>
                      })} */}
                    </AvatarGroup>
                  :
                    <AvatarGroup classes={{avatar: classes.avatarSmall, root: classes.avatarGroup}} max={3}>
                      <Avatar key={0} className={classes.avatarSmall}/>
                      <Avatar key={1} className={classes.avatarSmall}/>
                      <Avatar key={2} className={classes.avatarSmall}/>
                      <Avatar key={3} className={classes.avatarSmall}/>
                      <Avatar key={4} className={classes.avatarSmall}/>
                    </AvatarGroup>}
                  {(this.state.is_member || this.state.is_organizer) && this.state.members.length > 0 && <Button variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonAddMemberSmall}`} onClick={() => this.setState({showInvitationLink: true}) }>
                    <Icon className={`material-icons-outlined notranslate`}>person_add</Icon>
                    <Hidden xsDown>Invite</Hidden>
                  </Button>}
                </div>
              </h2>
            </Paper>
          </div>

          {(this.state.showInvitationLink || (this.state.is_member || this.state.is_organizer) && this.state.members.length < 1) ?
            <div className={classes.travelStyleContainer}>
              <Paper elevation={0} className={classes.travelStylePaper}>
                <Grid container direction="row" alignItems='center' justify="center" spacing={1}>
                  <Grid item xs={12}>
                    {this.state.showInvitationLink &&
                      <IconButton aria-label="close" className={classes.closeButton} onClick={() => this.setState({showInvitationLink: false})}>
                        <Icon className="notranslate">close</Icon>
                      </IconButton>
                    }
                    <Typography variant="inherit" style={{ paddingBottom: 0, paddingLeft: 5, fontSize: "16px", textAlign: 'left', fontWeight: 700, display: 'block' }}>
                        <div style={{display: 'inline-block', padding: '0px 20px 0px 0px', verticalAlign: 'super', }}>
                          <AvatarGroup classes={{avatar: classes.avatarSmall}} max={3}>
                            <Avatar className={classes.avatarSmall}/>
                            <Avatar className={classes.avatarSmall}/>
                            <Avatar className={classes.avatarSmall}/>
                            <Avatar className={classes.avatarSmall}/>
                            <Avatar className={classes.avatarSmall}/>
                          </AvatarGroup>
                        </div>
                        <div style={{maxWidth: 750}}>
                          <br/>Invite up to 5 friends or family members<br/><br/>
                          <small style={{fontWeight: 500, color: "", marginBottom: 0}}>
                            Share this link with your friends or family members. After they take a travel style quiz and join this travel group, you will start exploring matching destinations that suit to all of you.<br/><br/>
                          </small>

                          <Grid item xs={12}>
                            <TextField classes={{root: classes.shareCodeField}} label={false} value={link} variant="outlined"
                              // InputProps={{
                              //   endAdornment: (
                              //     <InputAdornment position="end">
                              //       <Button size="small" variant="contained" className={classes.shareButtonBook}
                              //         onClick={() => {
                              //           navigator.clipboard.writeText(link)
                              //         }}>
                              //         Copy
                              //       </Button>
                              //     </InputAdornment>
                              //   ),
                              // }}
                            />
                          </Grid>
                        </div>

                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonBookOutlined} ${classes.travelStyleTestBtn}`} onClick={this.copyLink.bind(this,  link)}>
                      <Icon className={`material-icons-outlined notranslate`} style={{marginRight: 5}}>link</Icon> Copy link
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </div>
          :
          ((this.state.is_member || this.state.is_organizer) ?
            <Fragment>
              {/* See matching trips */}
              <div className={classes.categoriesContainer} style={{paddingTop: 15, paddingLeft: 10, marginTop: 20, marginBottom: -60}}>
                <Tabs
                  value={false}
                  variant="scrollable"
                  scrollButtons="off"
                  aria-label="scrollable auto"
                >
                  <CustomTab key={-1}><ButtonFilter name="saved" defaultSelected={[]} selected={this.state.filters.saved} buttonIcon="favorite_border" buttonIconSelected="favorite" label="Saved" multiple={false} onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                  <CustomTab key={1}><SliderFilter name="budget" defaultValue={4000} selected={this.state.filters.budget} min={100} max={4000} step={50} prependLabel="" appendLabel="" description="Max. budget: " label="Budget" onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                  <CustomTab key={0}><ListFilter name="things_to_do" defaultSelected={['all']} selected={this.state.filters.things_to_do} description="What places are you interested in ?" label="Interest" list={this.props.user && this.props.user.travel_preference ? INTERESTS.concat(THINGS_TO_DO).filter(interest => [].concat(this.props.user.travel_preference.things_to_do).concat(["popular"]).includes(interest.value)) : INTERESTS.concat(THINGS_TO_DO)} onChange={this.handleFiltersChange.bind(this)} /></CustomTab>
                  <CustomTab key={3}><SliderFilter name="weather" defaultValue={[-20, 40]} selected={this.state.filters.weather} min={-20} max={40} step={10} appendLabel=" °C" description="Temperature: " label="Weather" onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                  <CustomTab key={2}><ListFilter name="distance" defaultSelected={[]} selected={this.state.filters.distance} description="How far do you want to travel ?" label="Distance" list={DISTANCE} onChange={this.handleFiltersChange.bind(this)}/></CustomTab>

                  {/* <CustomTab key={-1}><ButtonFilter name="saved" defaultSelected={[]} selected={this.state.filters.saved} buttonIcon="favorite_border" buttonIconSelected="favorite" label="Saved" multiple={false} onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                  <CustomTab key={1}><SliderFilter name="budget" defaultValue={4000} selected={this.state.filters.budget} min={100} max={4000} step={50} prependLabel="" appendLabel="" description="Max. budget: " label="Budget" onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                  <CustomTab key={3}><SliderFilter name="weather" defaultValue={[-20, 40]} selected={this.state.filters.weather} min={-20} max={40} step={10} appendLabel=" °C" description="Temperature: " label="Weather" onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                  <CustomTab key={0}><ListFilter name="things_to_do" defaultSelected={[]} selected={this.state.filters.things_to_do} description="What places are you interested in ?" label="Interest" list={this.props.user && this.props.user.travel_preference ? THINGS_TO_DO.filter(interest => this.props.user.travel_preference.things_to_do.includes(interest.value)) : THINGS_TO_DO} onChange={this.handleFiltersChange.bind(this)}/></CustomTab>
                  <CustomTab key={2}><ListFilter name="distance" defaultSelected={[]} selected={this.state.filters.distance} description="How far do you want to travel ?" label="Distance" list={DISTANCE} onChange={this.handleFiltersChange.bind(this)}/></CustomTab> */}
                </Tabs>
              </div>

              <div className="destinations-container" style={{overflow: 'hidden'}}>
                {(this.state.destination_groups.length < 1 && !this.state.isLoading) && <Grid item xs={12} className={classes.showcaseDestinations}>
                  <Typography gutterBottom variant="inherit" style={{ paddingBottom: 0, fontSize: "100%", textAlign: 'center', fontWeight: 400, display: 'block' }}>
                    <h2 className={classes.showcaseHeadline}>
                      <Typography className={classes.showcaseHeadline}>No results</Typography>
                      <small className={classes.showcaseSubtitle} style={{fontSize: "80%"}}>Change some filters or clear them all</small>

                      <Button variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonBook}`} style={{float: 'inherit', marginTop: '20px', marginLeft: 0, boxShadow: 'none'}} onClick={this.clearFilters}>
                        Clear all
                      </Button>
                    </h2>
                  </Typography>
                </Grid>}

                <InfiniteScroll
                  dataLength={this.state.destination_groups.length} //This is important field to render the next data
                  next={this.getDestinations}
                  hasMore={this.state.hasMore}
                  // hasMore={(this.props.interests || 'all') === 'all' || this.props.interests === 'discover-weekly' || this.props.interests === 'saved' ? this.state.hasMore : false}
                  loader={<div className={classes.buttonLoading}>Loading...</div>}
                  style={{display: 'contents'}}
                  scrollThreshold={0.4}
                >
                  <Grid container spacing={2} className={classes.gridFilters}>
                    {((this.state.isLoading && this.state.destination_groups.length === 0) ? Array.from(new Array(1)) : this.state.destination_groups).map((group, i) => {
                      return <DestinationList key={group ? `${group.key}-${i}` : 'loading'}
                              search_params={this.state.search_params}
                              next_page_url={group && API + group.next_page_url}
                              destinations={group && group.destinations}
                              title={group && group.title}
                              description={group && group.description}
                              has_next_page={false}
                              link_to_all={group && group.link_to_all}
                              page={group && group.page}
                              pageSize={3}
                              group_name={group && group.key}
                              members={this.state.members}
                              member_id={this.state.member_id}
                              showHeader={false}
                              isLoading={this.state.isLoading}
                              onSelected={this.props.onSearch}
                              address={this.props.address}
                              addressType={this.props.addressType}
                              countryCode={this.props.countryCode}
                              locationFrom={(this.state.from_address ? this.state.from_address : 'nearby')}
                              infiniteScroll={false}
                              group_id={this.props.group_id}
                            />
                    })}
                  </Grid>
                </InfiniteScroll>
              </div>
            </Fragment>
            :
            <Fragment>
              {/* Join the trip */}
              <div className={classes.travelStyleContainer}>
                <Paper elevation={0} className={classes.travelStylePaper}>
                  <Grid container direction="row" alignItems='center' justify="center" spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="inherit" style={{ paddingBottom: 0, paddingLeft: 5, fontSize: "16px", textAlign: 'left', fontWeight: 700, display: 'block' }}>
                          {/* <div style={{display: 'inline-block', padding: '0px 20px 0px 0px', verticalAlign: 'super', }}>
                            <AvatarGroup classes={{avatar: classes.avatarSmall}} max={3}>
                              <Avatar className={classes.avatarSmall}/>
                              <Avatar className={classes.avatarSmall}/>
                              <Avatar className={classes.avatarSmall}/>
                              <Avatar className={classes.avatarSmall}/>
                              <Avatar className={classes.avatarSmall}/>
                            </AvatarGroup>
                          </div> */}
                          <div style={{maxWidth: 750}}>
                            <br/>Join this travel group<br/><br/>
                            <small style={{fontWeight: 500, color: "", marginBottom: 0}}>
                              Sign in to Travelities, take a short quiz about your travel style and join this travel group. You will start seeing matching destinations that suit to all of you.<br/><br/>
                            </small>
                          </div>

                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      {this.props.user.is_registered ?
                        <Button variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonBookOutlined} ${classes.travelStyleTestBtn}`} onClick={this.joinGroup}>
                          <Icon className={`material-icons-outlined notranslate`} style={{marginRight: 5}}>person_add</Icon> Join the group
                        </Button>
                      :
                        <Button variant="contained" color="primary" size="small" disableElevation className={`${classes.buttonBookOutlined} ${classes.travelStyleTestBtn}`} onClick={this.openSigninModal}>
                          Sign in
                        </Button>
                      }
                    </Grid>
                  </Grid>
                </Paper>
              </div>
            </Fragment>
            )
          }
        </div>

        <Menu
          anchorEl={this.state.anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          id={menuId}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={isMenuOpened}
          onClose={this.handleMenuClose}
          classes={{paper: classes.menuPaper}}
        >
          <MenuItem onClick={() => this.setState({showEditDialog:  true, isMenuOpened: false})}>
            <ListItemText primary="Rename" classes={{primary: classes.listItemText, secondary: classes.listItemTextSecondary}} />
          </MenuItem>
          <Divider style={{margin: '5px 0px'}} />
          <MenuItem onClick={this.handleLeaveGroup}>
            <ListItemText primary={'Leave the group'} classes={{primary: classes.listItemText, secondary: classes.listItemTextSecondary}} />
          </MenuItem>
        </Menu>

        <Dialog classes={{root: classes.editDialogRoot, paper: classes.editDialogPaper}} disableBackdropClick={true} disableEscapeKeyDown={true} aria-labelledby="customized-dialog-title" fullWidth={true} maxWidth={'sm'} open={this.state.showEditDialog}>
          <DialogTitle id="customized-dialog-title">
            <IconButton aria-label="close" className={classes.closeButton} onClick={this.handleDialogClose}>
              <Icon className="notranslate">close</Icon>
            </IconButton>
            <Box style={{marginTop: 7, float: 'left'}}>
              Edit
            </Box>
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus={false}
              name="name"
              label=""
              placeholder="Name"
              helperText=""
              variant="outlined"
              margin="dense"
              value={this.state.name}
              onChange={this.handleChange}
              className={classes.textfield}
            />
            <Typography gutterBottom style={{fontSize: 12, color: '#828282', fontWeight: 500}}>
              <Icon className={`material-icons-outlined notranslate ${classes.icon}`}>lock</Icon> This name will be visible only to you
              <br/><br/>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button disabled={this.state.name && this.state.name.trim() !== '' ? false : true} variant="contained" onClick={this.handleUpdateGroup} color="primary" className={classes.buttonBook} >
              {this.props.isSubmitting ?
                <Fragment>Saving...</Fragment>
                :
                <Fragment>Save</Fragment>
              }
            </Button>
          </DialogActions>
        </Dialog>

      </Fragment>
    )
  }
}

const styles = theme => ({
  h3: {
    fontWeight: 800,
    fontSize: 20,
    margin: '30px 0px 10px 0px',
  },
  headlinePaper: {
    padding: '0px 0px 40px 0px',
    margin: '-100px auto',
    color: '#333',
    // textAlign: 'left',
    width: '100%',
    position: 'relative',
    boxShadow: 'none',
    height: '100%',
    // minHeight: '60vh',
    paddingBottom: '96px',
    backgroundColor: 'transparent',
    // background: 'linear-gradient(180deg, rgb(26 83 53 / 9%) 0%, rgb(205 214 208 / 77%) 100%)',

    [theme.breakpoints.down('sm')]: {
      paddingBottom: 4,
    },
  },
  headline: {
    maxWidth: 1119,
    // width: '100%',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: 28,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: '30px',
    padding: '120px 20px 10px 20px',

    [theme.breakpoints.down('xs')]: {
      fontSize: 25,
      padding: '99px 20px 10px 20px',
    },
  },
  subtitle: {
    fontWeight: 500,
    fontSize: '50%',
    color: '#828282',
    display: 'block',
    marginTop: 14,
  },
  gridFilters: {
    textAlign: 'left',
    maxWidth: 1142,
    margin: '60px auto 0px auto',
    width: 'calc(100% - 0px)',
    overflow: 'hidden',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  icon: {
    fontSize: 21,
    fontWeight: 600,
    marginTop: 0,
    marginRight: 0,
    marginLeft: -5,
    padding: '8px !important',
    verticalAlign: 'middle',
    color: '#02c39a',
  },
  buttonAddMemberSmall: {
    height: 32,
    fontSize: '13px',
    fontWeight: 900,
    backgroundColor: 'transparent',
    color: '#02c39a',
    border: '2px solid #02c39a',
    borderRadius: 45,
    padding: '18px 10px',
    minWidth: 10,
    verticalAlign: 'super',

    [theme.breakpoints.down('xs')]: {
      padding: '18px 6px',
    },

    '&:hover': {
      color: '#fff',
      border: '2px solid transparent',
    }
  },
  buttonBookOutlined: {
    color: '#02c39a',
    margin: '10px -6px 10px 10px',
    border: '2px solid #02c39a',
    textTransform: 'none',
    borderRadius: 45,
    fontWeight: 800,
    // boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    padding: '13px 30px',
    // minWidth: 155,

    '&:hover': {
      border: '2px solid transparent',
      boxShadow: 'none',
    }
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px -6px 10px 10px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    // boxShadow: 'none',
    borderRadius: 45,
    fontWeight: 800,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    padding: '13px 30px',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  categoriesContainer: {
    width: '102%',
    margin: '10px auto -20px auto',
    maxWidth: 1137,
    paddingRight: 0,
    top: -1,
    whiteSpace: 'nowrap',
    overflowX: 'auto',

    position: 'sticky',
    backgroundColor: '#fff',
    zIndex: 100,
    paddingTop: 10,
    // boxShadow: '0 10px 20px -22px rgb(0 0 0 / 52%)',

    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 10px)',
    },
  },
  travelStyleContainer: {
    maxWidth: 1119,
    // width: '100%',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: 28,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: '40px',
    padding: '0px 20px',

    [theme.breakpoints.down('xs')]: {
      padding: '0px 10px',
    },
  },
  travelStylePaper: {
    border: '1px solid #e5e5e5',
    padding: '20px',
    marginTop: 0,
    marginBottom: 0,
    backgroundImage: 'url(/discover-weekly-background.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '0px -4px',

    [theme.breakpoints.down('xs')]: {
      backgroundPosition: '0px -1px',
      margin: '20px auto 0px auto',
    },
  },
  travelStyleIcon: {
    verticalAlign: 'middle',
    float: 'left',
    padding: '14px',
    margin: '0px 20px 0px 10px',
    backgroundColor: '#fff',
    color: '#02c39a',
    borderRadius: 25,
    display: 'block',

    ["@media (max-width:704px)"]: {
      display: 'none !important',
    },

    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  travelStyleTestBtn: {
    margin: '0px 10px 0px 0px !important',
    float: 'left',
    color: '#fff',
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',

    [theme.breakpoints.down('xs')]: {
      margin: '10px auto 0px auto !important',
      float: 'left',
    },
  },
  avatarSmall: {
    width: 36,
    height: 36,
    fontSize: '15px',
    fontWeight: 800,
    backgroundColor: '#fff',
    color: '#02c39a',
    borderColor: '#02c39a',
  },
  avatarGroup: {
    float: 'left',
    marginRight: 5,
  },
  showcaseDestinations: {
    margin: '100px 0px 40px 0px',

    [theme.breakpoints.down('xs')]: {
      margin: '100px 0px 30px 0px',
    },
  },
  showcaseHeadline: {
    fontSize: '30px',
    fontWeight: 800,
    color: '#000',
    textDecoration: 'none',

    [theme.breakpoints.down('xs')]: {
      fontSize: '25px',
      marginBottom: -5,
    },
  },
  showcaseSubtitle: {
    fontWeight: 600,
    fontSize: '50% !important',
    // fontSize: '12px',
    color: '#828282',
    display: 'block',
    marginTop: 12,
  },
  buttonLoading: {
    color: '#02c39a',
    textDecoration: 'none',
    margin: '27px auto',
    display: 'block',
    position: 'relative',
    fontSize: '15px',
    fontWeight: 600,
    padding: '13px 20px 13px 27px',
    backgroundColor: 'transparent',
    borderRadius: 50,
    border: '2px solid #02c39a',
    width: 65,
  },
  shareCodeField: {
    marginBottom: 10,
    marginLeft: -5,
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 15,

    '& .MuiOutlinedInput-root': {
      fontSize: 14,

      '& fieldset': {
        borderRadius: 15,
      },
    },
  },
  shareButtonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px -6px 10px 10px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  closeButton: {
    float: 'right',
  },
  menuBox: {
    float: 'right',
    border: '1px solid #ddd',
    marginRight: 0,
  },
  menuIcon: {
    fontSize: 20,
    color: '#999',
  },
  menuPaper: {
    margin: '10px 0px',
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
  },
  listItemText: {
    fontSize: 14,
    fontWeight: 600,
  },
  listItemTextSecondary: {
    fontSize: 11,
    fontWeight: 500,
    color: '#999',
  },

  editDialogRoot: {
    textAlign: 'left'
  },
  editDialogPaper: {
    margin: 10,
    width: '100%',
  },
  textfield: {
    backgroundColor: '#fff',
    marginTop: 5,
    width: '94%',
    borderRadius: 50,
    borderWidth: 1,
    padding: 9,
    boxShadow: '0 2.5px 5px 0 rgba(0, 0, 0, 0.05)',
    fontWeight: 500,
    border: '1px solid #eee',

    '& fieldset': {
      borderColor: 'transparent !important',
      borderWidth: 1,
      borderRadius: 25,
      paddingLeft: 30,
      fontWeight: 500,
    },

    '&:hover fieldset': {
      borderColor: 'transparent !important',
      borderWidth: 1,
      borderRadius: 25,
      paddingLeft: 30,
    },
  },
  icon: {
    fontSize: 14,
    fontWeight: 600,
    marginTop: -3,
    marginRight: 0,
    marginLeft: 10,
    padding: '5px !important',
    verticalAlign: 'middle',
    color: '#828282',
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 10px 10px 10px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    // boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    padding: '13px 30px',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
})

export default withRouter(withStyles(styles)(GroupHome))
